import * as Utils from '../utils.js';
import { Amount } from "./Amount.js";
/**
 * Class that represents an [[Account]] or [[Group]] balance on a window of time (Day / Month / Year).
 *
 * @public
 */
export class Balance {
    constructor(container, balancePlain) {
        this.container = container;
        this.payload = balancePlain;
    }
    /**
     * The day of the balance. Days starts on 1 to 31.
     *
     * Day can be 0 (zero) in case of Monthly or Early [[Periodicity]] of the [[BalancesReport]]
     */
    getDay() {
        return this.payload.day;
    }
    /**
     * The month of the balance. Months starts on 1 (January) to 12 (December)
     *
     * Month can be 0 (zero) in case of Early [[Periodicity]] of the [[BalancesReport]]
     */
    getMonth() {
        return this.payload.month;
    }
    /**
     * The year of the balance
     */
    getYear() {
        return this.payload.year;
    }
    /**
     * Date object constructed based on [[Book]] time zone offset. Usefull for
     *
     * If Month or Day is zero, the date will be constructed with first Month (January) or Day (1) of the next period.
     */
    getDate() {
        var year = this.getYear();
        var month = this.getMonth();
        var day = this.getDay();
        if (month == null || month == 0) {
            year++;
        }
        if (day == null || day == 0) {
            month++;
        }
        var date = Utils.createDate(year, month, day, this.container.getBalancesReport().getBook().getTimeZoneOffset());
        return date;
    }
    /**
     * The Fuzzy Date of the balance, based on [[Periodicity]] of the [[BalancesReport]] query, composed by Year, Month and Day.
     *
     * The format is **YYYYMMDD**. Very usefull for ordering and indexing
     *
     * Month and Day can be 0 (zero), depending on the granularity of the [[Periodicity]].
     *
     * *Example:*
     *
     * **20180125** - 25, January, 2018 - DAILY Periodicity
     *
     * **20180100** - January, 2018 - MONTHLY Periodicity
     *
     * **20180000** - 2018 - YEARLY Periodicity
     */
    getFuzzyDate() {
        return this.payload.fuzzyDate;
    }
    /**
     * The cumulative balance to the date, based on the credit nature of the container
     */
    getCumulativeBalance() {
        return Utils.getRepresentativeValue(this.getCumulativeBalanceRaw(), this.container.isCredit());
    }
    /**
     * The raw cumulative balance to the date.
     */
    getCumulativeBalanceRaw() {
        return new Amount(this.payload.cumulativeBalance);
    }
    /**
     * The cumulative credit to the date.
     */
    getCumulativeCredit() {
        return new Amount(this.payload.cumulativeCredit);
    }
    /**
     * The cumulative debit to the date.
     */
    getCumulativeDebit() {
        return new Amount(this.payload.cumulativeDebit);
    }
    /**
     * The balance on the date period, based on credit nature of the container.
     */
    getPeriodBalance() {
        return Utils.getRepresentativeValue(this.getPeriodBalanceRaw(), this.container.isCredit());
    }
    /**
     * The raw balance on the date period.
     */
    getPeriodBalanceRaw() {
        return new Amount(this.payload.periodBalance);
    }
    /**
     * The credit on the date period.
     */
    getPeriodCredit() {
        return new Amount(this.payload.periodCredit);
    }
    /**
     * The debit on the date period.
     */
    getPeriodDebit() {
        return new Amount(this.payload.periodDebit);
    }
}
//# sourceMappingURL=Balance.js.map